module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-route-tab', _vm._b({
    on: {
      "click": _vm.onClick
    }
  }, 'q-route-tab', _vm.objectBindings, false), [_vm._v("\n  " + _vm._s(_vm.translatedLabel) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-083f5ea3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AuthenticatedNavigationItem.vue
// module id = 1808
// module chunks = 0